var React = require("react");
var map = require('lodash/collection/map');
var Icon = require('infl-icons').Icon;
var SelectDropdown = require("patternity/lib/select_dropdown");
var reject = require("lodash/collection/reject");
var pluck = require("lodash/collection/pluck");
var includes = require('lodash/collection/includes');
var trunc = require('lodash/string/trunc');
var isEmpty = require('lodash/lang/isEmpty');

var HubSwitcher = React.createClass({
  getInitialState: function() {
    return {
      open: false
    }
  },
  getDefaultProps: function() {
    return {
      family: {
        companies: []
      }
    };
  },
  componentDidMount: function() {
    document.addEventListener('click', this.handleClickOutside);
  },
  render: function() {
    return (
      <div id="hub-switcher-wrap" key="dropdown" onClick={this._toggleDropdown} ref="area">
        {this._selectAHub()}
        {this._switcherContent()}
      </div>
    )
  },
  _switcherContent: function() {
    var content = (
      <div className="company-wrap">
        {this._family()}
        {this._others()}
      </div>
    );

    return this.state.open ? content : null;
  },
  _selectAHub: function() {
    return (
      <div className="switcher-select">
        <span className="switcher-select-content">Select a Program {this._determineIcon()}</span>
      </div>
    );
  },
  _others: function() {
    return (
      <ul className="others-wrap">
        {this._companyList(this.props.others)}
      </ul>
    );
  },

  _family: function() {
    return (
      <ul className="family-wrap">
        {isEmpty(this.props.family.name) ? null : this._familyGroup()}
        {this._companyList(this.props.family.companies)}
      </ul>
    );
  },

  _familyGroup: function() {
    return (
      <li className="switcher-family">
        <img src={this.props.family.icon} /> {this.props.family.name}
      </li>
    );
  },

  _companyList: function(companies) {
    return map(companies, function(c) {
      var truncatedName = trunc(c.name, {length: 30});
      var currentHub = includes(c.host_names, window.location.host);

      return (
        <li className='switcher-company' key={c.id}>
          <a href={c.switch_url}>
            <img src={c.icon} />
            <span>{truncatedName}</span>
            {currentHub ? <Icon icon='check' /> : ''}
          </a>
        </li>
      )
    });
  },
  _toggleDropdown: function(e) {
    this.setState({open: !this.state.open});
  },

  handleClickOutside: function(e) {
    var area = this.refs.area;

    if (!area.contains(e.target)) {
      this.setState({open: false});
    }
  },
  _determineIcon: function() {
    return this.state.open ? <Icon icon="chevron-up" /> : <Icon icon="chevron-down" />;
  },
  _switchHub: function() {
    event.target.value ? window.location.replace(event.target.value) : null;
  }
});

module.exports = HubSwitcher;



// WEBPACK FOOTER //
// ./src/components/hub_switcher.jsx